<template>
  <section class="content">
    <admin-header
      :title="'Tariffs'"
      :uploader="true"
      :showNewButton="false"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
      :disableQuickSearch="true"
    >
      <div style="display:inline;" slot="admin-header-slot">
        <div @click="clickOnExpiring" class="btn btn-primary sq pull-right" data-toggle="tooltip" title="Expiring Tariffs - uploaded dates MUST follow yyyy-mm-dd format!">
          Expiring Tariffs
        </div>
      </div>
      <select class="sq btn btn-success" slot="buttons" v-model="tariffMode">
        <option value="search"></option>
        <option value="new">New Tariff</option>
        <option value="update">Mass Update</option>
        <option value="suspend">Mass Suspension</option>
        <option value="unsuspend">Mass Unsuspension</option>
      </select>
    </admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  import AdminHeader from '../AdminHeader'
  import event from '../../../../event.js'
  import API from '../../../../api/endpoints'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminTariff',
    data () {
      return {
        newEntityScreen: 'Admin - Tariffs',
        searchEntityScreen: 'Admin - Tariff search',
        filterEventName: 'admin-tariff-filter',
        filterName: 'TariffFilter',
        entityName: 'lookup',
        tariffMode: 'new'
      }
    },
    watch: {
      tariffMode (newVal, oldVal) {
        switch (newVal) {
          case 'new':
            this.$router.push({ name: this.newEntityScreen })
            break
          case 'suspend':
            this.showFilter('suspend')
            break
          case 'unsuspend':
            this.showFilter('unsuspend')
            break
          case 'update':
            this.showFilter('update')
            break
        }
      },
      '$route' (newVal, oldVal) {
        if (newVal.name.toLowerCase().includes('search') || newVal.name.toLowerCase().includes('edit')) {
          this.tariffMode = 'search'
        }
      }
    },
    methods: {
      clickOnExpiring (e) {
        e.stopPropagation()
        document.getElementById('expiring-tariffs').click()
      },
      showFilter (filter) {
        event.$emit('right-open', { callerId: this._uid, component: this.filterName, data: { action: filter }, event: this.filterEventName })
      },
      removeNulls (data) {
        let req = {}
        if (data.hasOwnProperty('action')) {
          req.action = data.action
        }
        if (data.hasOwnProperty('l')) {
          req.l = {}
          for (let prop in data.l) {
            if (data.l[prop] !== null && data.l[prop] !== '') {
              req.l[prop] = data.l[prop]
            }
          }
        }
        if (data.hasOwnProperty('lD')) {
          req.lD = {}
          for (let prop in data.lD) {
            if (data.lD[prop] !== null && data.lD[prop] !== '') {
              req.lD[prop] = data.lD[prop]
            }
          }
        }
        return req
      },
      respondToFilterRequest (data) {
        if (!this.searchEntityScreen) {
          window.console.warn(`If you can view this message, Admin Screen component '${this.$options.name}' has not set the searchEntityScreen data member`)
        } else {
          this.$router.push({ name: this.searchEntityScreen, query: { [btoa('search')]: btoa(JSON.stringify(this.removeNulls(data))) } })
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminTariff.vue?4a7b0bee